class CountUp {
    constructor() {
        this.countUps = document.querySelectorAll('.js-count-up');
        if (this.countUps.length) {
            this.countUps.forEach(() => {
                CountUp.bind();
            });
        }
    }

    static bind() {
        const elems = [...document.querySelectorAll('.number-value')];
        const values = elems.map((el) => parseInt(el.dataset.numberValue, 10));
        const min = Math.min(...values);
        elems.forEach((elem) => {
            const start = 0;
            const end = parseInt(elem.dataset.numberValue, 10);
            const interval = Math.floor(end / min);
            let fired = false;
            window.addEventListener('scroll', () => {
                if (CountUp.isInViewport(elem) && !fired) {
                    CountUp.countUp(elem, start, end, interval);
                    fired = true;
                }
            }, false);
        });
    }

    static isInViewport(element) {
        const headerContent = document.querySelector('.header-content');
        const bounding = element.getBoundingClientRect();
        if (
            (bounding.top - headerContent.offsetHeight) >= 0 && bounding.left >= 0
            && bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
            && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        ) {
            return true;
        }
        return false;
    }

    static countUp(target, count, end, interval) {
        if (target.classList.contains('count-up-finished')) {
            return;
        }
        let sum = count;
        target.innerHTML = count.toLocaleString('en-US');
        if (count < end) {
            sum += interval;
            setTimeout(() => CountUp.countUp(target, sum, end, interval), 10);
        } else {
            target.innerHTML = end.toLocaleString('en-US');
            target.classList.add('count-up-finished');
        }
    }
}

export default CountUp;
